import React, { useState } from "react";

const DataTableWithHeaderSettings = ({ data }) => {
    const allHeaders = data && data.length > 0 ? Object.keys(data[0]) : [];
    const [selectedHeaders, setSelectedHeaders] = useState(allHeaders);

    const toggleHeader = (header) => {
        setSelectedHeaders((prev) =>
            prev.includes(header)
                ? prev.filter((h) => h !== header)
                : [...prev, header]
        );
    };

    const createTableFromJson = (data, selectedHeaders) => {
        if (!data || data.length === 0) return null;

        return (
            <table style={{ borderCollapse: "collapse", width: "100%", marginTop: "20px" }}>
                <thead>
                    <tr>
                        {selectedHeaders.map((col) => (
                            <th
                                key={col}
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    textAlign: "left",
                                }}
                            >
                                {col}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index} style={{ cursor: "pointer" }}>
                            {selectedHeaders.map((col) => (
                                <td
                                    key={col}
                                    style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                    }}
                                >
                                    {row[col]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <div>
            <h3>⚙️ Select Columns to Display:</h3>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                {allHeaders.map((header) => (
                    <label key={header}>
                        <input
                            type="checkbox"
                            checked={selectedHeaders.includes(header)}
                            onChange={() => toggleHeader(header)}
                        />{" "}
                        {header}
                    </label>
                ))}
            </div>

            {createTableFromJson(data, selectedHeaders)}
        </div>
    );
};

export default DataTableWithHeaderSettings;
